import React from 'react';
import {isNotEmpty} from "@Array/isNotEmpty";
import BestPricesList from "./BestPricesList";
import Translation from "@Translation/components/Translation";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";

interface BestPriceOnDateRouteListProps {
    bestPriceOnDateData: BestPriceRouteType[],
    index: string,
    activeTab: string,
}

function BestPriceOnDateRouteList({bestPriceOnDateData, index, activeTab}: BestPriceOnDateRouteListProps) {
    return (
        <div className="station-to-station-results">
            <div className={`tab-pane ${index === activeTab ? 'active' : ''}`} id={`panel__${index}`}>
                {isNotEmpty(bestPriceOnDateData) ? (
                    <BestPricesList
                        bestPriceOnDateData={bestPriceOnDateData}
                    />
                ) : (
                    <Translation translationKey="no_res.no_results_title"/>
                )}
            </div>
        </div>
    )
}

export default BestPriceOnDateRouteList